import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-dialog-memory-calc",
    templateUrl: "./dialog-memory-calc.component.html",
    styleUrls: ["./dialog-memory-calc.component.scss"],
})
export class DialogMemoryCalcComponent implements OnInit {
    dataSource: any;

    displayedColumns = [
        "procedureName",
        "procedureCode",
        "currencyProcedure",
        "procedurePercentageApplied",
        "valueProcedure",
        "discountProcedure",
        "valueProcedureFinal",
        "currencyUco",
        "valueUco",
        "ucoPercentageApplied",
        "discountUco",
        "valueUcoFinal",
    ];

    constructor(
        public _matDialogRef: MatDialogRef<DialogMemoryCalcComponent>,
    ) { }

    ngOnInit() {
    }

    dimiss() {
        this._matDialogRef.close();
    }
}
